import type { ScreenTour, ScreenTourMap } from './types';

/** Inicio (tablero): resumen diario de una ruta y vista global. */
const home: ScreenTour = {
  key: 'screen-home',
  guide: 'primeros-pasos',
  steps: [
    { text: 'tours.home.welcome' },
    { text: 'tours.home.onboarding', target: 'home-onboarding' },
    { text: 'tours.home.tabs', target: 'home-tabs' },
    { text: 'tours.home.office', target: 'home-office' },
    { text: 'tours.home.route', target: 'home-route' },
    { text: 'tours.home.dates', target: 'home-dates' },
    { text: 'tours.home.query', target: 'home-query' },
    { text: 'tours.home.empty', target: 'home-empty' },
    // Indicadores: solo si la consulta trajo cierres.
    { text: 'tours.home.payments', target: 'home-stat-payments' },
    { text: 'tours.home.loans', target: 'home-stat-loans' },
    { text: 'tours.home.expenses', target: 'home-stat-expenses' },
    { text: 'tours.home.discounts', target: 'home-stat-discounts' },
    { text: 'tours.home.interest', target: 'home-stat-interest' },
    { text: 'tours.home.refinance', target: 'home-stat-refinance' },
    { text: 'tours.home.clients', target: 'home-stat-clients' },
    { text: 'tours.home.paymentCount', target: 'home-stat-paymentCount' },
    { text: 'tours.home.cash', target: 'home-stat-cash' },
    { text: 'tours.home.cashDifference', target: 'home-stat-cashDifference' },
    { text: 'tours.home.net', target: 'home-stat-net' },
    { text: 'tours.home.coverage', target: 'home-stat-coverage' },
    { text: 'tours.home.chart', target: 'home-chart' },
    { text: 'tours.home.table', target: 'home-by-route' },
  ],
};

export const homeTours: ScreenTourMap = {
  '/': home,
  '/dashboard': home,
};
